// removed by extract-text-webpack-plugin
module.exports = {"dropzone":"src-scripts-components-CreateUsersDrag-__createUsersDrag___dropzone","dropzoneActive":"src-scripts-components-CreateUsersDrag-__createUsersDrag___dropzoneActive","holder":"src-scripts-components-CreateUsersDrag-__createUsersDrag___holder","accept":"src-scripts-components-CreateUsersDrag-__createUsersDrag___accept","reject":"src-scripts-components-CreateUsersDrag-__createUsersDrag___reject","dropContainer":"src-scripts-components-CreateUsersDrag-__createUsersDrag___dropContainer"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/CreateUsersDrag/createUsersDrag.css
// module id = 2733
// module chunks = 0